import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { blogPost, ThemesDetail, Chapter } from '../../../Models/Session';
import { BaseApiService } from '../../../Services/base-api.service';


@Component({
  selector: 'app-show-blog-post',
  templateUrl: './show-blog-post.component.html',
  styleUrls: ['./show-blog-post.component.css'],standalone:false
})
export class ShowBlogPostComponent  implements OnInit{


  sessionDataArray: blogPost[] = [];
  sessionData1: ThemesDetail[] = [];
  selectedRecord!: Chapter;
  recordForm!: FormGroup;
  selected:boolean=false;
  loading:boolean=false;
  constructor(
    private api:BaseApiService,
    private http:HttpClient,private messageService:MessageService,private fb: FormBuilder)
  {

      this.recordForm = this.fb.group({
        id: new FormControl(0),
        title: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        metaDescription: new FormControl('', [Validators.required]),
        image:new FormControl('', [Validators.required])
      });

  }
  getdat(){
    this.loading=true;
    this.api.read("Blog").subscribe
    (
      (response)=>{
        this.sessionDataArray = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }
  ngOnInit(): void {
     // Initialize the form with an empty record
    this.getdat();

    if (this.sessionDataArray && this.sessionDataArray.length > 0) {
      this.recordForm.patchValue(this.selectedRecord);
    }

   }


   selectRecord(record: any) {
    this.selected=true;
    this.selectedRecord = record;
    this.recordForm.patchValue(record);
  }
  selectRecord1(record: any) {

    this.selectedRecord = record;
    this.recordForm.patchValue(record);
    this.deRecord();
  }
  deRecord() {
    this.loading=true;
    this.recordForm.get('status')?.setValue("Draft");
    const updatedRecord = this.recordForm.value;
    this.api.update("BlogApi",updatedRecord).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response });
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }

  updateRecord() {
    this.loading=true;
    const updatedRecord = this.recordForm.value;
    this.api.update("BlogApi",updatedRecord).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response });
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }


  getSubjects(){
    this.loading=true;
    this.api.read("SchoolTheme/Gethemes").subscribe
     (
      (response)=>{
        this.sessionData1 = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

}
